'use client'

import {useEffect, useRef, useState} from "react";

import Map from 'ol/Map'
import View from 'ol/View'
import TileLayer from 'ol/layer/Tile'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import {Cluster, OSM} from "ol/source";
import {fromLonLat, transform} from "ol/proj";
import {Feature} from "ol";
import {Coordinate} from "ol/coordinate";
import {Point} from "ol/geom";
import {FeatureGeoJSON, FeatureGeoJSONLayer} from "@/lib/client/ol/features";

// const lineFeature = new Feature(new LineString([[-1e7, 1e6], [-1e6, 3e6],]));
const pointFeature = new Feature(new Point(fromLonLat([1.373173901791856, 43.655812443196645])));
// const polygonFeature = new Feature(new Polygon([[[-3e6, -1e6], [-3e6, 1e6], [-1e6, 1e6], [-1e6, -1e6], [-3e6, -1e6],],]));
// const features:Feature[] = [createIconPoint([1.373173901791856, 43.655812443196645], 'Test'), pointFeature]



interface Props {
  features?: any[],
  zoom?: number,
  center: Coordinate //lng, lat
  onClick?: (lngLat: Coordinate, map: Map) => void
  onSelectFeature?: (feature: Feature) => void
  onSelectFeatures?: (features: Feature[]) => void
  onRefetch?: (center: [number, number], zoom: number, bounds: [number, number, number, number]) => void
}

export const MapBox = ({features, zoom, center, onClick, onSelectFeature, onSelectFeatures, onRefetch}: Props) => {
  let [map, setMap] = useState<Map | undefined>();
  const [clusterFeaturesLayer, setClusterFeaturesLayer] = useState<VectorLayer<Cluster> | undefined>();
  const [clusterSource, setClusterSource] = useState<Cluster | undefined>();
  const [shapeSource, setShapeSource] = useState<VectorSource | undefined>();
  const mapElement = useRef<any>()

  let ready = false;
  // let initMap: Map;
  let initialClusterFeaturesLayer: VectorLayer<Cluster>
  let initialShapeFeaturesLayer: VectorLayer<VectorSource>
  let initClusterSource: Cluster;
  let initShapeSource: VectorSource;


  useEffect(() => {
    console.log('MAPBOX initialize map element ?')
    if (!mapElement.current || map || !zoom || !center) {
      return
    }


    setMap(new Map({
      target: mapElement.current,
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
        FeatureGeoJSONLayer([FeatureGeoJSON('Point', center, { 'place_type': 'here'})]),
        // initialClusterFeaturesLayer
      ],
      view: new View({
        projection: 'EPSG:3857', //4326
        center: transform(center, 'EPSG:4326', 'EPSG:3857'), zoom: zoom, minZoom: 0, maxZoom: 28,
      }), controls: []
    }))

  }, [mapElement, map, center, zoom]);

  useEffect(() => {
    console.log("MAPBOX initialize center maker")
    if(!map || !center){
      return
    }


  }, [map, center]);

  // initialize map on first render - logic formerly put into componentDidMount
  useEffect(() => {
    console.log('useffect main')
    if (!mapElement.current || map ) {
      return
    }

    // shapes ----

    // const collection = {
    //   "type": "FeatureCollection",
    //   "features": readFeatures(features, center)
    // }
    //
    // // console.log('features:', collection)
    // //@ts-ignore
    // initShapeSource = new VectorSource({
    //   features: new GeoJSON().readFeatures(collection, {
    //     dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857'
    //   }),
    // })
    //
    // initialShapeFeaturesLayer = new VectorLayer({
    //   source: initShapeSource, style: shapeStyleFunction, visible: true
    // })
    //
    // // cluster ----
    //
    // initClusterSource = new Cluster({
    //   //@ts-ignore
    //   distance: 10, minDistance: 20, source: new VectorSource({
    //     features: new GeoJSON().readFeatures(collection, {
    //       dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857'
    //     }),
    //   }),
    // });
    //
    // initialClusterFeaturesLayer = new VectorLayer({
    //   source: initClusterSource, style: clusterStyleFunction, visible: true
    // })




    // initMap.once('rendercomplete', function (e) {
    //   // var newZoom = initMap.getView().getZoom();
    //   console.log('rendercomplete : ', e);
    //   ready = true
    // });
    //
    // initMap.on('moveend', function (e: MapEvent) {
    //   // const coordinate = getMouseCoordinate(e)
    //   if (ready) {
    //     const bounds = initMap.getView().calculateExtent(initMap.getSize())
    //     const tBounds = [transformEPSG4326([bounds[0], bounds[3]]), transformEPSG4326([bounds[2], bounds[1]])]
    //     const center = transformEPSG4326(initMap.getView().getCenter()!)
    //     const zoom = initMap.getView().getZoom()!
    //     if (onRefetch) {
    //       // @ts-ignore
    //       onRefetch(center, zoom, tBounds)
    //     }
    //   }
    // });
    //
    // initMap.on('change', function (e) {
    //   var newZoom = initMap.getView().getZoom();
    //   console.log('change: ', newZoom);
    // });
    //
    // initMap.on('dblclick', function (e: MapBrowserEvent<UIEvent>) {
    //   const coordinate = getMouseCoordinate(e)
    //   console.log('dblclick:', coordinate);
    // });
    //
    // initMap.once('postrender', function (e) {
    //   // var newZoom = initMap.getView().getZoom();
    //   console.log('postrender : ', e);
    // });
    //
    //
    // initMap.on('propertychange', function (e) {
    //   console.log('propertychange:', e);
    // });
    //
    // initMap.on('singleclick', function (e: MapBrowserEvent<UIEvent>) {
    //   const coordinate = getMouseCoordinate(e)
    //   console.log('singleclick:', coordinate);
    // });
    //
    // initMap.on('click', (evt: MapBrowserEvent<UIEvent>) => {
    //   const coordinate = getMouseCoordinate(evt)
    //   console.log('click ', coordinate)
    //
    //   const feature = initMap.forEachFeatureAtPixel(evt.pixel, function (feature: any) {
    //     return feature;
    //   });
    //
    //   // not select features? then click on map
    //   if (!feature || feature.length == 0) {
    //     if (onClick) {
    //       onClick(coordinate, initMap)
    //     }
    //     return;
    //   }
    //   if (onSelectFeature && feature.get('features') && feature.get('features').length == 1) {
    //     onSelectFeature(feature.get('features')[0])
    //   }
    //
    //   if (onSelectFeatures && feature.get('features') && feature.get('features').length > 1) {
    //     onSelectFeatures(feature.get('features'))
    //   }
    // });

    // fit map to feature extent (with 100px of padding)
    // initMap.getView().fit(initialShapeFeaturesLayer.getSource()!.getExtent(), {
    //   padding: [50, 50, 50, 50]
    // })

    // change mouse cursor when over marker
    // initMap.on('pointermove', function (e: any) {
    //   const pixel = initMap.getEventPixel(e.originalEvent);
    //   const hit = initMap.hasFeatureAtPixel(pixel);
    //   // initMap.getTarget()!.style.cursor = hit ? 'pointer' : '';
    // });

    // setMap(initMap)
    // setClusterSource(initClusterSource)
    // setShapeSource(initShapeSource)
    // setClusterFeaturesLayer(initialClusterFeaturesLayer)

  }, [mapElement.current])

  // useEffect(() => {
  //   if (!map) {
  //     return
  //   }
  //   map.getView().setCenter(transform(center, 'EPSG:4326', 'EPSG:3857'))
  //   map.getView().setZoom(zoom ? zoom : 20)
  // }, [zoom, center])

  // useEffect(() => {
  //   if (!map) {
  //     return
  //   }
  //
  //   if (clusterSource) {
  //     const source = clusterSource.getSource()
  //     if (source) {
  //       source.clear()
  //       const d = new GeoJSON().readFeatures({
  //         "type": "FeatureCollection",
  //         "features": readFeatures(features)
  //       }, {
  //         dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857'
  //       })
  //       //@ts-ignore
  //       source.addFeatures(d)
  //     }
  //   }
  //   if (shapeSource) {
  //     shapeSource.clear()
  //     //@ts-ignore
  //     shapeSource.addFeatures(new GeoJSON().readFeatures({
  //       "type": "FeatureCollection", "features": readFeatures(features)
  //     }, {
  //       dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857'
  //     }))
  //
  //   }
  // }, [clusterSource, features, map, shapeSource])

  return <div className="overflow-hidden flex h-72">
    <div ref={mapElement} className="h-full w-full bg-gray-500"/>
  </div>
}
